module.exports = __webpack_public_path__ + "img/background_c2_mobile.b32f3f42.jpg";